
import React, { useRef, useEffect } from 'react';
import LoadContainer from '../../shared/LoadContainer';


export default function ViewTeams () {


    return (
        <LoadContainer>
            <img className='shared--img-fill' src={process.env.PUBLIC_URL + '/img/location-aerial/bkg--location-aerial.jpg'} width='1920' height='1080' alt='' style={{ marginTop: 100}} />
        </LoadContainer>    
    );

}